import * as React from "react";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import { makeStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import axios from "axios";
import { CircularProgress } from "@mui/material";

import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import EditIcon from "@mui/icons-material/EditNote";
import Divider from "@mui/material/Divider";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 450,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  paddingTop: 2,
  paddingBottom: 2,
  paddingLeft: 3,
  paddingRight: 3,
  borderRadius: "10px",
};

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
      width: "35ch",
      borderRadius: "15%",
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    overflow: "hidden",
  },
  paper: {
    position: "absolute",
    width: 300,
    backgroundColor: "#fff",
    boxShadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    padding: 20,
    outline: "none",
    borderRadius: "2%",
    overflow: "hidden",
  },
  button: {
    textTransform: "lowercase",
  },
  heading: {
    fontFamily: "Goudy Bookletter 1911, sans-serif",
    fontSize: "16px",
    marginBottom: "10px",
  },
  label: {
    fontWeight: "bold",
  },
  formContainer: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    marginTop: "5%",
  },
  fieldContainer: {
    display: "flex",
    alignItems: "center",
  },
  buttonContainer: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1rem",
  },
  divider: {
    margin: "20px 0",
  },
}));

export default function MyContentLinkForm({ selectedOption }) {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setEditMode(false);
    setShowAdvanced(false);
    setNewKey("");
    setNewValue("");
  };
  const headers = useSelector((state) => state.header);
  const classes = useStyles();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccessMessage] = useState();
  const api = localStorage.getItem("api");
  const curremms = useSelector((state) => state.curremms);
  const [showAdvanced, setShowAdvanced] = useState(false);
  const [editMode, setEditMode] = useState(false);

  const dispatch = useDispatch();

  const oldLocationData = useSelector((state) => state.location);
  const [eventName, setEventName] = useState();
  const [customProperties, setCustomProperties] = useState({});

  const [newKey, setNewKey] = useState("");
  const [newValue, setNewValue] = useState("");
  const [contentLink, setContentLink] = useState("");

  const toggleAdvanced = () => {
    setShowAdvanced((prev) => {
      const newShowAdvanced = !prev;
      if (!newShowAdvanced) {
        setEditMode(false);
      }
      return newShowAdvanced;
    });
  };

  const toggleEditMode = () => {
    setEditMode((prev) => !prev);
  };
  const handleCustomPropertyChange = (event) => {
    const { name, value } = event.target;
    // Update customProperties in formData based on input field changes
    setCustomProperties((prevFormData) => ({
      ...prevFormData,
      customProperties: {
        ...prevFormData.customProperties,
        [name]: value,
      },
    }));
  };
  const handleAddCustomProperty = () => {
    if (newKey && newValue) {
      setCustomProperties((prevFormData) => ({
        ...prevFormData,
        customProperties: {
          ...prevFormData.customProperties,
          [newKey]: newValue,
        },
      }));
      setNewKey("");
      setNewValue("");
    }
  };

  const emmsheaders = useSelector((state) => state.emmsheader);
  const handleContentChange = async (e) => {
    const file = e.target.value;
    if (file) {
      try {
        setContentLink(file);
      } catch (error) {
        console.error("Error reading link", error);
      }
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmitting(true);
    let formData = new FormData();

    const requestBody = {
      path: "eventcustomisation",
      query: {
        eventName: eventName,
        fallbackContent:true
      },
      emmsId: `${selectedOption}`,
      requestType: "POST",
      headers: {
        ...emmsheaders?.emmsheaders?.headers,
      },
    };

    formData.append("jsonData", JSON.stringify(requestBody));

    if (contentLink) {
      formData.append("mediaLink", contentLink);
    }

    const newHeaders = {
      Authorization: headers.headers.Authorization,
    };

 
    axios
      .post(api + `/emms/piggyback/formdata`, formData, { headers: newHeaders })
      .then((response) => {
        setIsSubmitting(false);
       
        setErrorModalOpen(true);

        setErrorMessage(
          `Content uploaded successfully.Refresh after few min to see the content`
        );

        setSuccessMessage(true);
      })
      .catch((error) => {
        console.log(error);
        setErrorModalOpen(true);

        setErrorMessage(`Error uploading content: ${error?.response?.data}`);
        setSuccessMessage(false);
      });
  };

  const handleChange = (e) => {
    setEventName(e.target.value);
  };

  const handleModalClose = () => {
    setErrorModalOpen(false);
    setErrorMessage("");
    setOpen(false);
    setIsSubmitting(false);
  };
  const getLabelWithAsterisk = (labelText, isRequired) => {
    return (
      <div style={{ display: "flex", alignItems: "center", width: "100px" }}>
        <label className={classes.label} htmlFor={labelText}>
          {labelText}
        </label>
        {isRequired && <span style={{ color: "red" }}>*</span>}
      </div>
    );
  };

  return (
    <div>
      <Button
        style={{ textTransform: "none" }}
        variant="contained"
        color="primary"
        onClick={handleOpen}
      >
        Use Link
      </Button>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <form
            className={classes.root}
            noValidate
            autoComplete="off"
            onSubmit={handleSubmit}
          >
            <div>
              <h2>Content Library</h2>
              <h4 style={{ fontWeight: "100" }}>
                Add content for {curremms?.curremms?.name}{" "}
              </h4>
            </div>

            {!showAdvanced && (
              <div className={classes.formContainer}>
                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Event Name:", true)}
                  <TextField
                    required
                    id="eventName"
                    label="Event Name"
                    name="eventName"
                    margin="none"
                    size="small"
                    variant="outlined"
                    value={eventName}
                    onChange={handleChange}
                  />
                </div>

                <div className={classes.fieldContainer}>
                  {getLabelWithAsterisk("Upload content:", true)}
                  <TextField
                    required
                    id="contentLink"
                    label="Content Link"
                    name="contentLink"
                    margin="none"
                    size="small"
                    variant="outlined"
                    value={contentLink}
                    onChange={handleContentChange}
                  />
                </div>
              </div>
            )}

            <div className={classes.buttonContainer}>
              <Button
                style={{
                  textTransform: "none",
                }}
                variant="outlined"
                color="primary"
                onClick={toggleAdvanced}
                startIcon={showAdvanced ? <ArrowBackIcon /> : null}
              >
                {showAdvanced ? "Back" : "Advanced"}
              </Button>
              {showAdvanced && (
                <Button
                  style={{
                    textTransform: "none",
                  }}
                  variant="contained"
                  color="primary"
                  onClick={toggleEditMode}
                  endIcon={!editMode ? <EditIcon /> : null}
                >
                  {editMode ? "Save Changes" : "Edit JSON"}
                </Button>
              )}
              {!showAdvanced && (
                <Button
                  style={{
                    textTransform: "none",
                  }}
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={handleSubmit}
                  disabled={isSubmitting}
                >
                  {isSubmitting ? <CircularProgress size={24} /> : "Submit"}
                </Button>
              )}
            </div>
            {showAdvanced && editMode && (
              <div
                style={{
                  maxWidth: "500px",
                  marginTop: "10px",
                  padding: "10px",
                  border: "1px solid #ccc",
                }}
              >
                <h6>Edit Custom Properties</h6>
                <div>
                  {Object.keys(customProperties).map((key) => (
                    <div key={key} style={{ margin: "15px 0" }}>
                      <TextField
                        id={key}
                        name={key}
                        label={key}
                        variant="outlined"
                        size="small"
                        value={customProperties[key]}
                        onChange={handleCustomPropertyChange}
                      />
                    </div>
                  ))}
                </div>
                {Object.keys(customProperties).length > 0 && (
                  <div className={classes.divider}>
                    <Divider />
                  </div>
                )}
                <div style={{ display: "flex", alignItems: "center" }}>
                  <TextField
                    id="newKey"
                    name="newKey"
                    label="New Key"
                    variant="outlined"
                    size="small"
                    value={newKey}
                    onChange={(e) => setNewKey(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <TextField
                    id="newValue"
                    name="newValue"
                    label="New Value"
                    variant="outlined"
                    size="small"
                    value={newValue}
                    onChange={(e) => setNewValue(e.target.value)}
                    style={{ marginRight: "10px" }}
                  />
                  <Button
                    style={{ textTransform: "none" }}
                    variant="contained"
                    color="primary"
                    onClick={handleAddCustomProperty}
                  >
                    Add
                  </Button>
                </div>
              </div>
            )}
            <div className={classes.jsoncontainer}>
              {showAdvanced && (
                <div
                  style={{
                    maxWidth: "500px",
                    marginTop: "10px",
                    padding: "10px",
                    border: "1px solid #ccc",
                  }}
                >
                  <h6>Custom Properties</h6>
                  <pre
                    style={{
                      whiteSpace: "pre-wrap",
                      wordWrap: "break-word",
                    }}
                  >
                    {JSON.stringify(customProperties, null, 2)}
                  </pre>
                </div>
              )}
            </div>

            <Modal
              open={errorModalOpen}
              onClose={handleModalClose}
              className={classes.modal}
            >
              <div className={classes.paper}>
                {success ? <h2>Congratulations</h2> : <h2>Error</h2>}
                <p>{errorMessage}</p>
                <Button
                  style={{
                    textTransform: "none",

                    marginLeft: "75%",
                  }}
                  onClick={handleModalClose}
                  variant="contained"
                  color="primary"
                >
                  Close
                </Button>
              </div>
            </Modal>
          </form>
        </Box>
      </Modal>
    </div>
  );
}
